<template>
    <ul class="list-group list-group-flush tx-13">
        <li v-for="item in transitems" :key="item.id" class="list-group-item d-flex pd-sm-x-20">
            <div class="avatar d-none d-sm-block"><span class="avatar-initial rounded-circle bg-teal"><i
                    class="icon ion-md-checkmark"></i></span></div>
            <div class="pd-sm-l-10">
                <p class="tx-medium mg-b-0">{{ item.narration.substring(0,22).concat('...') }}</p>
                <small class="tx-12 tx-color-03 mg-b-0">{{ item.txndate }}</small>
            </div>
            <div class="mg-l-auto text-right">
                <p class="tx-medium mg-b-0">+ {{ item.amount | toCurrency}}</p>
                <small class="tx-12 tx-success mg-b-0">{{ item.counterpartybank }}</small>
            </div>
        </li>
    </ul>
</template>
<script>
    export default {
        props : ['transitems'],
        name: 'ListItem'
    }
</script>
